module.exports = __webpack_public_path__ + "media/images/services/thumbnail/photo-100x100-a0ddc95395dd6f905605b7230a5ad85c.jpg";